import VueLoader from '../vue-loader'
import CustomerSupportForm from './form'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(CustomerSupportForm, document.getElementById('generalCustomerSupportForm'))
})
